import "./Insertion.css";
import { Link } from "react-router-dom";
import React from "react";

let arr = [];
let elem = '<div class="ins-block">';
let elem2 = "</div>";

function handleClick() {
	let num = Math.floor(Math.random() * 100);
	arr.push(num);
	document.getElementById("ins").innerHTML += elem + num + elem2;
}

function insertElement() {
	let index = parseInt(document.getElementById("enter-index").value);
	document.getElementById("ins").innerHTML = "";
	if (arr.length == 0 || index >= arr.length) {
		alert("Index out of bounds...");
	} else {
		for (let i = 0; i <= arr.length; i++) {
			if (i < index) {
				document.getElementById("ins").innerHTML +=
					elem + arr[i] + elem2;
			} else if (i == index) {
				document.getElementById("ins").innerHTML +=
					elem + document.getElementById("enter-num").value + elem2;
			} else {
				document.getElementById("ins").innerHTML += 
					elem + arr[i-1] + elem2;
			}
		}
	}
}

export default class Insertion extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		document.title = "Insertion in Arrays | Array Bundle";
		window.scroll(0, 0);
	}

	render() {
		return (
			<div className="subbundle-main">
				<h1 style={{textAlign: 'center', fontFamily: 'Gilroy', textDecoration: 'underline', fontSize: '2rem'}}><Link to="/">Go to Home</Link></h1>
				<h1>Insertion in Arrays</h1>
				<p>
					When the insertion happens at the beginning, it causes all
					the existing data items to shift one step downward. Here, we
					design and implement an algorithm to insert an element at
					the beginning of an array. It involves three cases:
				</p>
				<p>
					<b>
						1. Insertion at the beginning of an array <br />
						2. Insertion at the given index of an array <br />
						3. Insertion after the given index of an array <br />
						4. Insertion before the given index of an array <br />
					</b>
				</p>
				<img src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fres.cloudinary.com%2Fmonkey-codes%2Fimage%2Fupload%2Fv1494831769%2Falgorithms%2Farray_insert_vjgpaz.gif&f=1&nofb=1" />
				<span>Insertion animation</span>

				{/* Insertion at the beginning */}
				<h2>Insertion at the beginning </h2>
				<p>
					When the insertion happens at the beginning, it causes all
					the existing data items to shift one step downward. Here, we
					design and implement an algorithm to insert an element at
					the beginning of an array.
				</p>
				<img src="https://cdn.discordapp.com/attachments/877930443473846324/902452910997245982/unknown.png" />
				<span>Insertion at the beginning</span>

				{/* Insertion at the given index */}
				<h2>Insertion at the given index</h2>
				<p>
					In this scenario, we are given the exact location (index) of
					an array where a new data element (value) needs to be
					inserted. First we shall check if the array is full, if it
					is not, then we shall move all data elements from that
					location one step downward. This will make room for a new
					data element.
				</p>
				<img src="https://cdn.discordapp.com/attachments/877930443473846324/902454793962930206/unknown.png" />
				<span>Insertion at the given index</span>

				{/* Insertion after the given index */}
				<h2>Insertion after the given index</h2>
				<p>
					In this scenario we are given a location (index) of an array
					after which a new data element (value) has to be inserted.
					Only the seek process varies, the rest of the activities are
					the same as in the previous example.
				</p>
				<img src="https://cdn.discordapp.com/attachments/877930443473846324/902454866050437130/unknown.png" />
				<span>Insertion after the given index</span>

				{/* Insertion before the given index */}
				<h2>Insertion before the given index</h2>
				<p>
					In this scenario we are given a location (index) of an array
					before which a new data element (value) has to be inserted.
					This time we seek till index-1 i.e., one location ahead of
					given index, rest of the activities are same as in previous
					example.
				</p>
				<img src="https://cdn.discordapp.com/attachments/877930443473846324/902454971679785030/unknown.png" />
				<span>Insertion before the given index</span>

				<hr />
				<h1>GAME TIME!</h1>
				<div className="subbundle-game-container">
					<h1 style={{ textAlign: "center", fontFamily: "Poppins" }}>
						Hover your mouse to look at the <br /> memory locations
						of each individual block...
					</h1>
				</div>
				<input id="enter-index" placeholder="Enter index" />
				<input id="enter-num" placeholder="Enter number" />
				<button onClick={insertElement} id="insert-btn">
					Insert
				</button>
				<div id="ins"></div>
				<div id="ins2"></div>
				<div className="insertion-trigger" onClick={handleClick}>
					Click
				</div>
				<div className="next-previous-div">
					<Link to="/games/arrays/rotation">
						<span>
							{"<"}Prev <b>Array Rotation</b>
						</span>
					</Link>
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					<Link to="/games/arrays/updation">
						<span>
							<b>Updation in Arrays </b>Next{">"}
						</span>
					</Link>
				</div>
			</div>
		);
	}
}
